import { render, staticRenderFns } from "./single.vue?vue&type=template&id=aac580b8&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&id=aac580b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac580b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac580b8')) {
      api.createRecord('aac580b8', component.options)
    } else {
      api.reload('aac580b8', component.options)
    }
    module.hot.accept("./single.vue?vue&type=template&id=aac580b8&scoped=true&", function () {
      api.rerender('aac580b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/singlechoice/single.vue"
export default component.exports